import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import loader from '@/components/Loader/store';
import flash from '@/components/FlashMessage/store';

import user from './user';
import app from './app';

const STORE_KEY = process.env.VUE_APP_STORE_KEY;
const namespace = 'enchi';
const key = `${namespace}.${STORE_KEY}`;

export let store; // eslint-disable-line

const storeLoader = async () => {
  const modules = {};
  switch(process.env.VUE_APP_MOD) {
    case 'admin':
      modules.dishes = (await import('@/AppAdmin/views/Dishes/store')).default;
      modules.users = (await import('@/AppAdmin/views/Users/store')).default;
      break;

    case 'app':
      modules.randomizer = (await import('@/App/views/Home/store')).default;
      break;

    default:
      break;
  }

  const vuexPersistLocal = createPersistedState({
    key,
    storage: window.localStorage,
    paths: ['user', 'app']
  });

  const vuexPersistSession = createPersistedState({
    key,
    storage: window.sessionStorage,
    paths: []
  });

  const plugins = [
    vuexPersistLocal,
    vuexPersistSession
  ];

  store = createStore({
    plugins,
    modules: {
      app,
      user,
      loader,
      flash,
      ...modules
    }
  });
};

storeLoader();

export default {};
